import { VISITED_USER_SEG_PARAM } from '@atlassian/jira-user-segmentation/src/constants.tsx';

export const hasVisitedUserSeg = (url: string): boolean => {
	// URLSearchParams#has is misbehaving on the server
	// which is why we're asserting against the URL string
	return url.includes(`${VISITED_USER_SEG_PARAM}=true`);
};
